import { getPartnerOnClientSide } from "@tm/insurance/utils";
import { PARTNER } from "@tm/isomorphic-utils";
import InsuranceListing from "./InsuranceListing/InsuranceListing";
import InsuranceListingRevamp from "./InsuranceListingRevamp/InsuranceListingRevamp";
import InsuranceListingV2 from "./InsuranceListingV2/InsuranceListingV2";
import {
  InsuranceListingWrapperProps,
  ListingPageProps,
  ListingPageV2Props,
  ListingRevampProps,
} from "./types";

const InsuranceListingWrapper = ({
  listingRevamp = true,
  onLoginRequest,
  ...props
}: InsuranceListingWrapperProps & { onLoginRequest?: () => void }) => {
  const partner = getPartnerOnClientSide();

  if (partner === PARTNER.MYPARTNER) {
    return <InsuranceListingV2 {...(props as ListingPageV2Props)} />;
  }

  if (listingRevamp) {
    return (
      <InsuranceListingRevamp
        {...(props as ListingRevampProps)}
        onLoginRequest={onLoginRequest}
      />
    );
  }

  return (
    <InsuranceListing listingData={(props as ListingPageProps).listingData} />
  );
};

export default InsuranceListingWrapper;
